export default function secondsToTime(seconds) {
  const fs = Math.floor(seconds)
  const m = Math.floor(fs / 60)
  const s = fs - (m * 60)

  return `${m > 9 ? m : `0${m}`}:${s > 9 ? s : `0${s}`}`
}
